import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Util } from '../interceptors/util';
import { CbtserviceService } from '../services/cbtservice.service';
import { ExamService } from '../services/exam.service';
import { ProctoringService } from '../services/proctoring.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-sebinstructionpage',
  templateUrl: './sebinstructionpage.component.html',
  styleUrls: ['./sebinstructionpage.component.css']
})
export class SebinstructionpageComponent implements OnInit {
  examid_scheduleid_externalexamurl: any;
  isLoading: boolean;
  userauthservice: any;
  logourl: any;
  externaltoken: any;
  externalportalname: any;
  fromexternalauth: any;
  downloadurl: any;
  sebDownloadLinkForWindows: string="https://todayssolutions.com.ng/secureexambrowser/SEB_103.11.0.0_SetupBundle.exe"
  sebDownloadLinkForMac: string="https://todayssolutions.com.ng/secureexambrowser/SafeExamBrowser-3.6.1.dmg"
  sebCurrentWindowsVersion: string = "103.11.0.0";
  setCurrentMacVersion:string = "3.6.1";
  activeTab: string = navigator.platform.toLowerCase().includes('mac') ? 'mac' : 'windows';
  sebExamLaunchUrl: SafeUrl = "";
  sebConfigDownldoadUrl: SafeUrl = "";
  isAtBottom: boolean = false; // to track if the user is at the bottom of the page
  isExamOutsideWebtest: boolean = false;

  constructor(public toastr: ToastrService, public activatedroute: ActivatedRoute, public router: Router, public util: Util, private examservice: ExamService,private cbtservice: CbtserviceService, private sanitizer:DomSanitizer, private languageService: LanguageService) { }
  get language() {
    return this.languageService.language;
  }

  async ngOnInit() {
    var query = this.activatedroute.snapshot.queryParams.query
    if (query) {
      this.examid_scheduleid_externalexamurl = query;
    }
    if (query && query.includes('externalexamurl=')) {
      this.isExamOutsideWebtest = true;
    }
    const subdomain = this.util.getSubdomain();
    if (subdomain) {
      this.isLoading = true;
      this.isLoading=false;
    }
    this.sebConfigDownldoadUrl = this.getSEBConfigUrl();
    this.sebExamLaunchUrl = this.launchSEBUrl();
    //await this.downloadsebconfig();

    //this.sebdownloadlink="https://pub-20042618721c4b1daa76c4e53384f296.r2.dev/SEB.exe";//r2cloudflare .dmg for mac(future update)
    //this.sebdownloadlink;//todayssolutions website godaddy .dmg for mac(future update)
    window.addEventListener('scroll', this.checkScroll.bind(this));

  }

ngOnDestroy() {
    // Clean up the event listener
    window.removeEventListener('scroll', this.checkScroll.bind(this));
}

checkScroll() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const threshold = 10; // pixels from bottom to consider as "bottom"
    
    this.isAtBottom = (windowHeight + scrollTop + threshold) >= documentHeight;
}

scrollPage() {
    if (this.isAtBottom) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
        window.scrollTo({ 
            top: document.documentElement.scrollHeight, 
            behavior: 'smooth' 
        });
    }
}
  // async downloadsebconfig() {
  //   this.isLoading=true
  //debugger
  //   var data= await this.examservice.getSEBConfig(this.examurl_examid_scheduleid).catch(err=>{this.cbtservice.showHttpError(err);this.isLoading=false;})
  //   const downloadedFile = new Blob([data as BlobPart], {
  //       type: data?.type
  //   });
  //   console.log("ddd", downloadedFile)
  //   if (downloadedFile.type != "") {
  //       const a = document.createElement('a');
  //       a.setAttribute('style', 'display:none;');
  //       document.body.appendChild(a);
  //       a.download = "ExamConfig.seb";
  //       a.href = URL.createObjectURL(downloadedFile);
  //       a.target = '_blank';
  //       a.click();
  //       document.body.removeChild(a);
  //   }    this.isLoading=false
  // }
  launchSEBUrl() {
    let url = `${this.examservice.rootS3DBURL}Exam/downloadsebconfig?${this.examid_scheduleid_externalexamurl}&company=${this.util.getSubdomain()}`;
    
    const platform = ((navigator as any).userAgentData?.platform ?? navigator.platform);

    const sebUrlPrefix = platform.toLowerCase().startsWith('mac') ? 'seb' : 'wseb';

    url = url.startsWith('https://') ? url.replace('https://', `${sebUrlPrefix}s://`)
         : url.startsWith('http://') ? url.replace('http://', `${sebUrlPrefix}://`)
         : `seb://${url}`;
    const safeUrl = this.sanitizer.bypassSecurityTrustUrl(url);
    //console.log(url);
    return safeUrl;
  }
  getSEBConfigUrl(){
    //sebs:cbtapi.webtest.ng/Exam/downloadsebconfig?&company=workforce
    //var a =`${encodeURI(this.examurl_examid_scheduleid ?? '')}`;
    let url = `${this.examservice.rootS3DBURL}Exam/downloadsebconfig?${this.examid_scheduleid_externalexamurl}&company=${this.util.getSubdomain()}`;
    const safeUrl = this.sanitizer.bypassSecurityTrustUrl(url);
    //console.log(url);
    return safeUrl;
  }
}
